import { createLucideIcon } from 'lucide-react';
export const PlusSquare = createLucideIcon('plus-square', [
  [
    'path',
    {
      d: 'M12 17V11.7619V7',
      key: '1fwujw',
    },
  ],
  [
    'path',
    {
      d: 'M17 12L11.7619 12H7',
      key: '1uc4f5',
    },
  ],
  [
    'path',
    {
      d: 'M20 4H4V20H20V4Z',
      key: '1bnaxz',
    },
  ],
]);
